"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.createBookingDeepLink = createBookingDeepLink;
exports.formatAvailabilityForGroupTiles = void 0;
exports.formatAvailabilityForTiles = formatAvailabilityForTiles;
exports.formatAvailabilityForTimeTiles = void 0;
exports.getLinkRel = getLinkRel;
exports.getScreenMedium = getScreenMedium;
exports.isMobileScreen = isMobileScreen;
exports.oldFormatAvailabilityForTiles = oldFormatAvailabilityForTiles;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _moment = _interopRequireDefault(require("moment"));
var _qs = _interopRequireDefault(require("qs"));
var _uiTheme = _interopRequireDefault(require("@kyruus/ui-theme"));
// Used by removed code flows, didn't want to delete everything incase we go back to xstate method
function oldFormatAvailabilityForTiles() {
  let availability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let bookOnlineUrl = arguments.length > 1 ? arguments[1] : undefined;
  return (0, _map.default)(availability).call(availability, _ref => {
    let {
      start_datetime,
      purpose: {
        name: purpose,
        patient_relationship: relationship
      },
      location_id
    } = _ref;
    const date = (0, _moment.default)(start_datetime).format('ddd, MMM DD');
    const time = (0, _moment.default)(start_datetime).format('h:mm A');
    const href = createBookingDeepLink({
      purpose,
      relationship,
      start_datetime,
      location_id,
      bookOnlineUrl
    });
    return {
      date,
      time,
      href
    };
  });
}
function formatAvailabilityForTiles() {
  let availability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let bookOnlineUrl = arguments.length > 1 ? arguments[1] : undefined;
  let isAvailabilityReadOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!availability) return [];
  return (0, _map.default)(availability).call(availability, _ref2 => {
    let {
      date,
      start,
      purpose,
      patient_relationship,
      location_id
    } = _ref2;
    const formattedDate = (0, _moment.default)(date).format('ddd, MMM DD');
    const time = (0, _moment.default)(date + ' ' + start).format('h:mm A');
    const href = !isAvailabilityReadOnly ? createBookingDeepLink({
      purpose,
      relationship: patient_relationship,
      start_datetime: date + ' ' + start,
      location_id,
      bookOnlineUrl
    }) : '';
    return {
      date: formattedDate,
      time,
      href,
      unformattedDate: date
    };
  });
}

/**
 * Formats availability for time tiles
 * @param {object[]} availability
 * @param {string} bookOnlineUrl
 * @param {boolean} isAvailabilityReadOnly
 * @returns {object[]} [{ time: '11:42 PM' href: 'https://book.me' } ...]
 */
const formatAvailabilityForTimeTiles = function () {
  let availability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let bookOnlineUrl = arguments.length > 1 ? arguments[1] : undefined;
  let isAvailabilityReadOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!availability) return [];
  return (0, _map.default)(availability).call(availability, _ref3 => {
    let {
      date,
      start,
      purpose,
      patient_relationship,
      location_id
    } = _ref3;
    const time = (0, _moment.default)(date + ' ' + start).format('h:mm A');
    const href = !isAvailabilityReadOnly ? createBookingDeepLink({
      purpose,
      relationship: patient_relationship,
      start_datetime: date + ' ' + start,
      location_id,
      bookOnlineUrl
    }) : '';
    return {
      href,
      time,
      unformattedDate: date
    };
  });
};

/**
 * Splits availability into groups by date
 * @param {object[]} availability
 * @param {boolean} includeCount
 * @returns {object[]} [{ date: 'Fri, Sep 07' count: 42 } ...]
 */
exports.formatAvailabilityForTimeTiles = formatAvailabilityForTimeTiles;
const formatAvailabilityForGroupTiles = function () {
  let availability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let includeCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!availability) return [];
  const availabilityGroups = (0, _reduce.default)(availability).call(availability, (acc, _ref4) => {
    let {
      date
    } = _ref4;
    const formattedDate = (0, _moment.default)(date).format('ddd, MMM DD');
    if (includeCount) {
      acc[formattedDate] = {
        count: (acc[formattedDate]?.count || 0) + 1,
        date: formattedDate,
        unformattedDate: date
      };
    } else {
      acc[formattedDate] = {
        date: formattedDate,
        unformattedDate: date
      };
    }
    return acc;
  }, {});
  return (0, _values.default)(availabilityGroups);
};
exports.formatAvailabilityForGroupTiles = formatAvailabilityForGroupTiles;
function createBookingDeepLink(_ref5) {
  let {
    purpose,
    relationship,
    start_datetime,
    location_id,
    bookOnlineUrl
  } = _ref5;
  const params = {
    purpose,
    relationship
  };
  if (start_datetime && location_id) {
    params.period_start = start_datetime;
    params.location_id = location_id;
  }
  const query = _qs.default.stringify(params);
  return bookOnlineUrl + ((0, _indexOf.default)(bookOnlineUrl).call(bookOnlineUrl, '?') > -1 ? '&' : '?') + query;
}
function getLinkRel(linkTarget) {
  return linkTarget === '_blank' ? 'noopener noreferrer' : '';
}
function getScreenMedium() {
  const {
    screen_medium
  } = _uiTheme.default; // '768px'
  const screenMedium = Number(screen_medium.substring(0, screen_medium.length - 2));
  return screenMedium;
}
function isMobileScreen() {
  return window.innerWidth <= getScreenMedium();
}